import type { ComponentRef, Ref } from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cx } from "class-variance-authority";

import * as styles from "./Slider.module.scss";

type RootProps = SliderPrimitive.SliderProps & {
  ref?: Ref<ComponentRef<typeof SliderPrimitive.Root>>;
};

const Root = ({ className, ref, ...props }: RootProps) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cx(styles.root, className)}
    {...props}
  />
);
Root.displayName = "Slider.Root";

type TrackProps = SliderPrimitive.SliderTrackProps & {
  ref?: Ref<ComponentRef<typeof SliderPrimitive.Track>>;
};

const Track = ({ className, ref, ...props }: TrackProps) => (
  <SliderPrimitive.Track
    ref={ref}
    className={cx(styles.track, className)}
    {...props}
  />
);
Track.displayName = "Slider.Track";

type RangeProps = SliderPrimitive.SliderRangeProps & {
  ref?: Ref<ComponentRef<typeof SliderPrimitive.Range>>;
};

const Range = ({ className, ref, ...props }: RangeProps) => (
  <SliderPrimitive.Range
    ref={ref}
    className={cx(styles.range, className)}
    {...props}
  />
);
Range.displayName = "Slider.Range";

type ThumbProps = SliderPrimitive.SliderThumbProps & {
  ref?: Ref<ComponentRef<typeof SliderPrimitive.Thumb>>;
};

const Thumb = ({ className, ref, ...props }: ThumbProps) => (
  <SliderPrimitive.Thumb
    ref={ref}
    className={cx(styles.thumb, className)}
    {...props}
  />
);
Thumb.displayName = "Slider.Thumb";

type SliderProps = RootProps;

const Slider = ({ ref, ...rootProps }: SliderProps) => (
  <Root ref={ref} {...rootProps}>
    <Track>
      <Range />
    </Track>
    {rootProps.value?.map((_, i) => (
      <Thumb key={i} />
    ))}
  </Root>
);
Slider.displayName = "Slider";

Slider.Root = Root;
Slider.Track = Track;
Slider.Range = Range;
Slider.Thumb = Thumb;

export { Slider };
